// components/Banner/Banner.jsx
import React from "react";
import "./Banner.css";

export const Banner = ({title }) => {
  return (
    <div className="banner">
          <div className="banner-text">{title}</div>
    </div>
  );
};
